import * as env from '@/env'

export default function DevModeBanner() {
	if (env.isProduction) return null

	const text = env.mode

	// let text = env.mode
	// if (env.isProduction) 
	// 	text = "testing, don't use yet!"

	return (
		<div className="bg-[repeating-linear-gradient(45deg,#fbbf24,#fbbf24_10px,#000_10px,#000_20px)] text-black p-2 text-center font-bold z-50 h-12">
			<p className="text-white text-lg drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">{text}</p>
		</div>
	)
}
